import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const generateFacebookAuthLink = ({ slug, params }) => axios.get(`${getWorkspaceId()}/traffic-sources/${slug}/integrations/facebook/auth/link`, { params })
const logoutFacebookAccount = (slug) => axios.get(`${getWorkspaceId()}/traffic-sources/${slug}/integrations/facebook/auth/logout`)
const checkFacebookCompleteAuth = ({ slug, params }) => axios.get(`${getWorkspaceId()}/traffic-sources/${slug}/integrations/facebook/auth/complete`, { params })

// facebook ads accounts
const getFacebookAdsAccounts = (slug) => axios.get(`${getWorkspaceId()}/traffic-sources/${slug}/integrations/facebook/ads-accounts`)
const updateFacebookAdsAccount = ({ slug, adsAccountId }) => axios.put(`${getWorkspaceId()}/traffic-sources/${slug}/integrations/facebook/ads-accounts/${adsAccountId}`)

// pixel
const getFacebookPixels = (slug) => axios.get(`${getWorkspaceId()}/traffic-sources/${slug}/integrations/facebook/pixels`)
const updatePixel = ({ slug, pixelId }) => axios.put(`${getWorkspaceId()}/traffic-sources/${slug}/integrations/facebook/pixels/${pixelId}`)

// data sources for params
const getParametersDataSources = () => axios.get(`${getWorkspaceId()}/traffic-sources/integrations/facebook/data-sources`)
const updateParametersDataSources = ({ slug, formData }) => axios.put(`${getWorkspaceId()}/traffic-sources/${slug}/integrations/facebook/customer-parameters/sources`, formData)

export {
    generateFacebookAuthLink,
    checkFacebookCompleteAuth,
    logoutFacebookAccount,
    getFacebookAdsAccounts,
    updateFacebookAdsAccount,
    getFacebookPixels,
    updatePixel,
    getParametersDataSources,
    updateParametersDataSources,
}
